import { render } from "./CustomerAccommodationInquiryDetailsView.vue?vue&type=template&id=9f0d04e2&ts=true&lang=pug"
import script from "./CustomerAccommodationInquiryDetailsView.vue?vue&type=script&lang=ts"
export * from "./CustomerAccommodationInquiryDetailsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__